/**
 * Bottom sheet built on Radix Dialog (PHASE1 §7.4) — the mobile counterpart to
 * Modal, sliding up from the bottom edge. Used by the mobile "Mehr" nav sheet.
 */
import * as Dialog from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';

export interface SheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  hideTitle?: boolean;
  children: ReactNode;
}

export function Sheet({ open, onOpenChange, title, hideTitle, children }: SheetProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-slate-900/40 backdrop-blur-sm" />
        <Dialog.Content className="fixed inset-x-0 bottom-0 z-50 max-h-[85vh] overflow-y-auto rounded-t-2xl bg-white px-4 pt-3 pb-[calc(1rem+env(safe-area-inset-bottom))] shadow-lg ring-1 ring-slate-900/5 focus:outline-none dark:bg-slate-900 dark:ring-white/10">
          <div className="mx-auto mb-3 h-1 w-10 rounded-full bg-slate-200 dark:bg-slate-700" />
          <div className={hideTitle ? 'sr-only' : 'px-1 pb-2'}>
            <Dialog.Title className="text-base font-semibold text-slate-900 dark:text-slate-100">
              {title}
            </Dialog.Title>
          </div>
          <div className="px-1 py-1">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
